
import './App.css';
import Header from './components/Header/Header';
import Main from './components/Main/Main';

function App() {
  return (
    <div>
      <Header key="header" />
      <Main key="main" />
    </div>
  );
}

export default App;
